 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"6a8501cbc3323442afa2","1":"8d322d855dc0e478f071","2":"f302fe3a035d3230b7fd","3":"8e0e8a8b16ae2850e660","4":"5fc58a00d03786f946a5","5":"603705054bc0e20914cb","6":"8ceced912573d96e173a","7":"8569b3c64067bd2a719d","vendors~Comment~ShareComment":"d832c6664aef265f5803","vendors~Comment~LoginDialog":"87bd30b89c1baceb3d3d","vendors~Comment~Survey":"0d483674a7e641654cbf","Comment":"812c7fc4d5ea92a8510a","vendors~Player":"d0fa9c2a11bcf933d0c2","Player":"7b91d3e89c0385033337","AccountOpening":"efcc12029fef887ee8a1","BackTopBottom":"68d39e0966e3137b543a","Caption":"2e2a69cb3952fe4d796d","Copyright":"c7d2142842ff69bc24a6","DataBox":"fabd9a23ec8db9a90797","Img":"ceb3ef7599d71828a7db","LivePlayer":"7de1b0f87bc0d9d01d69","MoreTabs":"9bfb49b41c959980e269","Nav":"c199bd56aa650747af2d","NormalCaption":"98ea7a0b35d9a285a78e","Offline":"bab1510e797e432acd96","QQShare":"049a54985c5a0a206793","Stick":"f7b27c9cc0676eed164c","Tip":"032a47bc228407604d01","ViewMoreLink":"5e92cd8c82b1d3f51d30","WxLaunchApp":"c59a5cbc35626afd49df","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"51e8e72153340c50a635","Atlas":"3aa9aee1dba3b11bd122","FiveNavPic":"6d1f07d6d48541faa395","FourNavPic":"b3ba07317a8b44c0e883","vendors~MdBanner":"8f735c8d571975e952d8","vendors~BigImage~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~CallupVideoAppHead~HomeFo~464104dc":"22b045198678fccbcfb4","CallupVideoAppHead":"d27ad735caea8ad8052f","HomeFooter":"0949e4c6bef6a3696e39","Hongbao":"478b78b31940b9a5308c","TwoImage":"2b133d4048340a08ee2d","ThreeNavPic":"0eb3fe79c1263f3dfbb6","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"56419c14b96b763198c2","BigImage":"cbd382250191112fb2c2","NoImage":"f767868bd67946a23566","OneImage":"bf9f801a8331261c547a","ThreeImage":"e237e2d0c0512d60a4cc","vendors~NewsStream":"4783d40e5b2081523a36","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"f9097ba08fc7c2e99c7d","SingleTitle":"9d73ed766c1be756ff77","TwoImg":"845dd07ac60599b7c770","InformationFlow":"45468ec52fab9fd30f52","vendors~BigImg":"d33ba96e930593c0784a","BigImg":"e574210780d6cf887db5","vendors~BigTopic~TitleImg":"f479855c657efcf7658a","BigTopic":"219fc5503df145241e75","TitleImg":"2b3fd520084877bb8808","vendors~SlideImg":"7de9ce3e93453c8210a7","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"574e959baba6b7952931","NormalSlides":"0c7b2cd247c321d45805","ShareSlides":"d215dc3461e302725bad","vendors~BottomSlides~UpgradeBottomSlides":"c42b11d5c6a6b6b1d7b0","UpgradeBottomSlides":"5bb6efb3dd90724afbf0","vendors~IndexSlides":"92746b34966bb36e1c0c","vendors~BrowserGuideLayer":"2b9a303acd26df8e56fb","vendors~CallupHead":"53100ee4c4690f83ea3c","vendors~ShareComment":"73a7f5d493d35d0b4ee4","vendors~Survey":"f34748c440d046c77a98","vendors~NormalTabs":"31e47d3a6e36495954f7","vendors~WXGuideLayer":"bd428dccbf7b3fe9e79c","LoginDialog":"5653fa7fabe1ce277e01","vendors~MarkTabs":"dfef5a3b5522b7d01af3","vendors~PageBottomBrand":"d737a145974d995bfb78","vendors~SimpleGuideLayer":"426fc9235ecd80dbe4ce","vendors~SlidesTabs":"12b4223fc2308150eb21","vendors~pics":"8c716d7f40461961a707","pics":"a16a6b2516cefa72fb1b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/list/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
